// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  font: 14px "Lucida Grande", Helvetica, Arial, sans-serif;
  padding: 0 !important;
  margin: 0 !important;
  overflow: hidden;
  -webkit-user-select: none;
  /* Safari */
  -ms-user-select: none;
  /* IE 10 and IE 11 */
  user-select: none;
  /* Standard syntax */
}

a {
  color: #00B7FF;
}

#map {
  position: absolute;
  top: 0;
  bottom: 0;
  width: 100%;
  opacity: 0;
}

#globalParameterWrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  opacity: 0;
  border: 1px solid black;
  background: rgba(0, 0, 0, 0.6);
  color: white;
  height: 25px;
  z-index: 2;
}

.ui-state-default,
.ui-widget-content .ui-state-default,
.ui-widget-header .ui-state-default,
.ui-button,
html .ui-button.ui-state-disabled:hover,
html .ui-button.ui-state-disabled:active {
  border: 1px solid #007eff;
}

#isochroneWheelMenu,
#yearWheelMenu {
  position: absolute;
  width: 100%;
  height: 100%;
  pointer-events: none;
  font-size: 18px;
}

#isochroneWheelMenu .highlight {
  stroke: red;
  stroke-width: 4px;
}

#yearWheelMenu .highlight {
  stroke: red;
  stroke-width: 4px;
}

#yearWheelMenu .highlight {
  stroke: red;
  stroke-width: 4px;
}

.isochronePopup .mapboxgl-popup-tip {
  display: none;
}

.isochronePopup .mapboxgl-popup-content {
  padding: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  height: 140px;
  width: 140px;
  border-radius: 50%;

  font-size: 16px;
}

#year-wrapper {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

#background-year-wrapper {
  display: flex;
  justify-content: center;
  z-index: 1;
  padding: 0px 20% 5px;
}

#year-label,
#year-text-from,
#year-from,
#year-text-until,
#year-until {
  color: white;
  font-size: 22px;
  white-space: pre;
  background-color: rgba(0, 0, 0, 0.6);
  cursor: pointer;
}

.sparkline-container svg {
  width: 100%;
  height: 100%;
}

.sparkline-container-detailed svg {
  width: 100%;
  height: 100%;
}



#sparklineGlobalScale:hover+#sparklineTrapezoid rect,
#sparklineGlobalScale:hover+#sparklineTrapezoid polygon {
  fill: rgba(255, 255, 0, 0.2);
}

#year-select-menu {
  display: flex;
  display: none;
  justify-content: center;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.6);
}


.ui-selectmenu-open {
  z-index: 1001;
}

#slider-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
}

.popup-maxwidth-300 {
  max-width: 300px !important;
}`, "",{"version":3,"sources":["webpack://./src/css/style.css"],"names":[],"mappings":"AAAA;EACE,wDAAwD;EACxD,qBAAqB;EACrB,oBAAoB;EACpB,gBAAgB;EAChB,yBAAyB;EACzB,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EACV,uBAAuB;EACvB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,UAAU;AACZ;;AAEA;;;;;;EAME,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,aAAa;EACb,YAAY;EACZ,kBAAkB;;EAElB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,oBAAoB;AACtB;;AAEA;;;;;EAKE,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,oCAAoC;EACpC,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;;AAIA;;EAEE,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,UAAU;EACV,oCAAoC;AACtC;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":["body {\n  font: 14px \"Lucida Grande\", Helvetica, Arial, sans-serif;\n  padding: 0 !important;\n  margin: 0 !important;\n  overflow: hidden;\n  -webkit-user-select: none;\n  /* Safari */\n  -ms-user-select: none;\n  /* IE 10 and IE 11 */\n  user-select: none;\n  /* Standard syntax */\n}\n\na {\n  color: #00B7FF;\n}\n\n#map {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  width: 100%;\n  opacity: 0;\n}\n\n#globalParameterWrapper {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  opacity: 0;\n  border: 1px solid black;\n  background: rgba(0, 0, 0, 0.6);\n  color: white;\n  height: 25px;\n  z-index: 2;\n}\n\n.ui-state-default,\n.ui-widget-content .ui-state-default,\n.ui-widget-header .ui-state-default,\n.ui-button,\nhtml .ui-button.ui-state-disabled:hover,\nhtml .ui-button.ui-state-disabled:active {\n  border: 1px solid #007eff;\n}\n\n#isochroneWheelMenu,\n#yearWheelMenu {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  pointer-events: none;\n  font-size: 18px;\n}\n\n#isochroneWheelMenu .highlight {\n  stroke: red;\n  stroke-width: 4px;\n}\n\n#yearWheelMenu .highlight {\n  stroke: red;\n  stroke-width: 4px;\n}\n\n#yearWheelMenu .highlight {\n  stroke: red;\n  stroke-width: 4px;\n}\n\n.isochronePopup .mapboxgl-popup-tip {\n  display: none;\n}\n\n.isochronePopup .mapboxgl-popup-content {\n  padding: 0;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  height: 140px;\n  width: 140px;\n  border-radius: 50%;\n\n  font-size: 16px;\n}\n\n#year-wrapper {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n\n#background-year-wrapper {\n  display: flex;\n  justify-content: center;\n  z-index: 1;\n  padding: 0px 20% 5px;\n}\n\n#year-label,\n#year-text-from,\n#year-from,\n#year-text-until,\n#year-until {\n  color: white;\n  font-size: 22px;\n  white-space: pre;\n  background-color: rgba(0, 0, 0, 0.6);\n  cursor: pointer;\n}\n\n.sparkline-container svg {\n  width: 100%;\n  height: 100%;\n}\n\n.sparkline-container-detailed svg {\n  width: 100%;\n  height: 100%;\n}\n\n\n\n#sparklineGlobalScale:hover+#sparklineTrapezoid rect,\n#sparklineGlobalScale:hover+#sparklineTrapezoid polygon {\n  fill: rgba(255, 255, 0, 0.2);\n}\n\n#year-select-menu {\n  display: flex;\n  display: none;\n  justify-content: center;\n  z-index: 1;\n  background-color: rgba(0, 0, 0, 0.6);\n}\n\n\n.ui-selectmenu-open {\n  z-index: 1001;\n}\n\n#slider-wrapper {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n}\n\n.popup-maxwidth-300 {\n  max-width: 300px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
